import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { handlePriceInput } from "../../utils/inputUtils";
import "./AccessorySalePreviewModal.css";
const money = (n) => "S/ " + Number(n || 0).toFixed(2);
const key = (x) => `${x.productId}:${x.variantId ?? "base"}`;
const price = (x) => Number(x.variantPrice ?? x.price ?? 0);
// Los precios del catálogo son números en soles (25.00).
// Los importes escritos con handlePriceInput son texto es-PE ("25,00").
// Se convierten por separado para evitar dividir el precio entre 100.
const catalogCentsOf = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
};
const paymentCentsOf = (value) => {
  const raw = String(value ?? "").trim().replace(/\s/g, "").replace(/[^\d.,]/g, "");
  if (!raw) return 0;
  // Admite 70.00 (Cards), 70,00 y 1.234,56 / 1,234.56.
  // El último separador es decimal cuando tiene 1 o 2 dígitos detrás.
  const lastDot = raw.lastIndexOf(".");
  const lastComma = raw.lastIndexOf(",");
  const lastSeparator = Math.max(lastDot, lastComma);
  let normalized;
  if (lastSeparator >= 0 && /^\d{1,2}$/.test(raw.slice(lastSeparator + 1))) {
    const whole = raw.slice(0, lastSeparator).replace(/\D/g, "");
    normalized = `${whole || "0"}.${raw.slice(lastSeparator + 1)}`;
  } else {
    normalized = raw.replace(/\D/g, "");
  }
  const number = Number(normalized);
  return Number.isFinite(number) ? Math.round(number * 100) : 0;
};
const methods = ["Efectivo", "Yape", "Plin", "Tarjeta", "Transferencia"];
// Cliente HTTP aislado, igual que Cards.jsx. No hereda interceptores
// registrados sobre el objeto axios global que gestionan el login.
const identityDni = axios.create({
  baseURL: "https://apiperu.dev/api/dni",
  headers: { Authorization: `Bearer ${process.env.REACT_APP_APIPERU_TOKEN || ""}`, "Content-Type": "application/json", Accept: "application/json" },
});
const identityRuc = axios.create({
  baseURL: "https://api.apiperu.dev/ruc",
  headers: { Authorization: `Bearer ${process.env.REACT_APP_APIPERU_TOKEN || ""}`, "Content-Type": "application/json", Accept: "application/json" },
});
export default function AccessorySalePreviewModal({ onClose }) {
  const [items, setItems] = useState([]),
    [loading, setLoading] = useState(true),
    [error, setError] = useState(""),
    [search, setSearch] = useState(""),
    [cart, setCart] = useState({}),
    [step, setStep] = useState(0);
  const [client, setClient] = useState({
    document: "",
    name: "",
    paternal: "",
    maternal: "",
    phone: "",
    email: "",
  });
  const [documentType, setDocumentType] = useState('DNI');
  const [receiptType,setReceiptType] = useState('03');
  const [issuedSale,setIssuedSale] = useState(null);
  const [documents,setDocuments] = useState([]);
  const [emissionBusy,setEmissionBusy] = useState(false);
  const [emissionError,setEmissionError] = useState('');
  const [pdfBusyId,setPdfBusyId] = useState(null);
  const [pdfError,setPdfError] = useState('');
  const [preflight,setPreflight] = useState(null);
   const [validatingReceipt,setValidatingReceipt] = useState(false);
  const [lookup, setLookup] = useState({ loading: false, error: '', success: false });
  const documentOptions = [{ value: 'DNI', label: 'DNI · Persona natural' }, { value: 'RUC', label: 'RUC · Empresa' }];
  const docLength = documentType === 'DNI' ? 8 : 11;
  useEffect(() => {
    const doc = client.document;
    if (doc.length !== docLength) {
      setLookup({ loading: false, error: '', success: false });
      return;
    }
    const token = process.env.REACT_APP_APIPERU_TOKEN;
    if (!token) {
      setLookup({ loading: false, error: 'No se configuró REACT_APP_APIPERU_TOKEN. No se puede verificar el documento.', success: false });
      return;
    }
    let active = true;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      if (!active) return;
      setLookup({ loading: true, error: '', success: false });
      try {
        const payload = documentType === 'DNI' ? { dni: doc } : { ruc: doc };
        const identityClient = documentType === 'DNI' ? identityDni : identityRuc;
        const res = await identityClient.post('/', payload, { signal: controller.signal });
        if (!active) return;
        const data = res.data?.data || res.data || {};
        if (res.data?.success === false) throw new Error(res.data?.message || 'Documento no encontrado');
        const values = documentType === 'DNI' ? {
          name: String(data.nombres || data.name || '').trim(),
          paternal: String(data.apellido_paterno || data.apellidoPaterno || data.paterno || '').trim(),
          maternal: String(data.apellido_materno || data.apellidoMaterno || data.materno || '').trim(),
        } : {
          name: String(data.razon_social || data.razonSocial || data.nombre_o_razon_social || data.nombre || '').trim(),
          paternal: '', maternal: '',
        };
        if (!values.name) throw new Error('La consulta no devolvió un nombre o razón social.');
        setClient(c => c.document === doc ? { ...c, ...values } : c);
        setLookup({ loading: false, error: '', success: true });
      } catch (err) {
        if (!active || axios.isCancel(err)) return;
        setLookup({ loading: false, error: err.response?.data?.message || err.message || 'No se pudo consultar el documento.', success: false });
      }
    }, 350);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [client.document, documentType, docLength]);
  const submittingRef = useRef(false);
  const requestKeyRef = useRef(null);
  const [submitting,setSubmitting] = useState(false);
  const [payments, setPayments] = useState([
    { method: "Efectivo", amount: "" },
  ]);
  useEffect(() => {
    const controller = new AbortController();
    axios
      .get(
        `${(process.env.REACT_APP_API || "/api").replace(/\/$/, "")}/accessory-sales/catalog`,
        { signal: controller.signal, withCredentials: true },
      )
      .then((r) => {
        if (!r.data?.success || !Array.isArray(r.data.data))
          throw Error("Respuesta de catálogo inválida");
        setItems(r.data.data);
      })
      .catch((e) => {
        if (e.code !== "ERR_CANCELED")
          setError(e.response?.data?.message || e.message);
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, []);
  useEffect(() => {
    const fn = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [onClose]);
  const selected = useMemo(
    () => items.filter((x) => cart[key(x)] > 0),
    [items, cart],
  );
  const total = selected.reduce((a, x) => a + cart[key(x)] * price(x), 0);
  const totalCents = selected.reduce((a, x) => a + cart[key(x)] * catalogCentsOf(price(x)), 0);
  const paidCents = payments.reduce((a, p) => a + paymentCentsOf(p.amount), 0);
  const paid = paidCents / 100;
  const validClient = lookup.success && client.document.length === docLength && !!client.name.trim() &&
    (documentType === 'RUC' || (!!client.paternal.trim() && !!client.maternal.trim())) &&
    /^9\d{8}$/.test(client.phone) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(client.email.trim());
  const validPayment = payments.length > 0 && payments.every(p => paymentCentsOf(p.amount) > 0) && paidCents === totalCents;
  const validationMessage = step === 0 && !selected.length ? 'Selecciona al menos un accesorio.' :
    step === 1 && !validClient ? 'Verifica DNI/RUC, nombres, celular de 9 dígitos y correo electrónico obligatorio y válido.' :
    step === 2 && !validPayment ? 'Los importes deben ser positivos y sumar exactamente el total.' : '';
  const verifyReceipt = async () => {
    setError('');setPreflight(null);setValidatingReceipt(true);
    try {
      const response=await axios.post(`${(process.env.REACT_APP_API || '/api').replace(/\/$/, '')}/accessory-sales/document-preflight`,{
        items:selected.map(x=>({productId:x.productId,variantId:x.variantId,quantity:cart[key(x)]})),
        documentType:receiptType,customerDocument:client.document
      },{withCredentials:true});
      if(!response.data?.success) throw Error('No se pudo validar el comprobante.');
      setPreflight(response.data.data);
    }catch(e){setError(e.response?.data?.message||e.message);}
    finally { setValidatingReceipt(false); }
  };
  const confirmSale = async () => {
    if(submittingRef.current || !selected.length || !validClient || !validPayment) return;
    submittingRef.current=true;setSubmitting(true);setError('');
    if(!requestKeyRef.current) requestKeyRef.current=`acc_${Date.now()}_${Math.random().toString(36).slice(2,14)}`;
    try {
      const response=await axios.post(`${(process.env.REACT_APP_API || '/api').replace(/\/$/, '')}/accessory-sales`,{
        requestKey:requestKeyRef.current,
        items:selected.map(x=>({productId:x.productId,variantId:x.variantId,quantity:cart[key(x)]})),
        checkout:{customer:client,payments:payments.map(p=>({method:p.method,amount:paymentCentsOf(p.amount)/100}))}
      },{withCredentials:true});
      if(!response.data?.success || response.data?.data?.status!=='PAID') throw Error('La venta no fue confirmada.');
      const confirmed=response.data.data;
      setIssuedSale(confirmed);
      if(receiptType!=='NV'){
        setEmissionBusy(true);
        try{
          const result=await axios.post(`${(process.env.REACT_APP_API || '/api').replace(/\/$/, '')}/accessory-sales/${confirmed.saleId}/documents/emit`,{
            documentType:receiptType,
            customer:{documentNumber:client.document,documentType:documentType==='RUC'?'6':'1',name:[client.name,client.paternal,client.maternal].filter(Boolean).join(' '),address:client.address||'',email:client.email}
          },{withCredentials:true});
          setDocuments(result.data?.data?.documents||[]);
        }catch(err){setEmissionError(err.response?.data?.message||err.message||'La venta está pagada, pero la emisión no se completó. No vuelva a registrar la venta.');}
        finally{setEmissionBusy(false);}
      }
    } catch(e){setError(e.response?.data?.message || e.message || 'No se pudo confirmar. Verifique el estado antes de reintentar.');}
    finally{submittingRef.current=false;setSubmitting(false);}
  };
  // Descargar con la misma sesión Axios utilizada por las demás rutas autenticadas.
  const downloadAccessoryPdf = async (doc) => {
    if (!issuedSale || pdfBusyId !== null) return;
    setPdfBusyId(doc.id);
    setPdfError('');
    try {
      const base = (process.env.REACT_APP_API || '/api').replace(/\/$/, '');
      const response = await axios.get(`${base}/accessory-sales/${issuedSale.saleId}/documents/${doc.id}/pdf`, {
        withCredentials: true,
        responseType: 'blob',
        headers: { Accept: 'application/pdf' },
      });
      const blob = response.data;
      const type = String(response.headers?.['content-type'] || blob?.type || '').toLowerCase();
      if (!type.includes('application/pdf') || !blob || blob.size < 5 ||
          (await blob.slice(0, 5).text()) !== '%PDF-') {
        throw new Error('El servidor no devolvió un PDF válido. Compruebe la ruta de generación del comprobante.');
      }
      const objectUrl = URL.createObjectURL(blob);
      try {
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = `${String(doc.full_number || `accesorio-${doc.id}`).replace(/[^a-zA-Z0-9_-]/g, '_')}.pdf`;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
      } finally {
        setTimeout(() => URL.revokeObjectURL(objectUrl), 30000);
      }
    } catch (err) {
      let message = err.response?.data?.message || err.message || 'No se pudo descargar el PDF.';
      if (err.response?.data instanceof Blob) {
        try { const data = JSON.parse(await err.response.data.text()); message = data.message || data.code || message; } catch (_) { /* Respuesta no JSON */ }
      }
      setPdfError(message);
    } finally { setPdfBusyId(null); }
  };
  const nextStep = () => { if (!validationMessage) setStep(s => Math.min(s + 1, 3)); };
  const change = (x, n) =>
    setCart((c) => ({
      ...c,
      [key(x)]: Math.max(
        0,
        Math.min(Number(x.available || 0), Math.floor(Number(n) || 0)),
      ),
    }));
  const setField = (k, v) => setClient((c) => ({ ...c, [k]: v }));
  if (issuedSale) {
    const accepted = documents.length > 0 && documents.every(d => d.sunat_status === 'ACCEPTED');
    const hasPending = emissionBusy || documents.some(d => !['ACCEPTED','OBSERVED'].includes(d.sunat_status));
    const docTitle = (d) => d.document_type === '01' ? 'Factura Electrónica' : d.document_type === '03' ? 'Boleta de Venta Electrónica' : 'Comprobante electrónico';
    return (
      <div className="acc-overlay">
        <section className="acc-modal acc-success-modal" role="dialog" aria-modal="true" aria-labelledby="acc-success-title">
          <button type="button" className="acc-success-close" aria-label="Cerrar" onClick={() => { onClose(); window.location.reload(); }}>×</button>
          <div className="acc-success-heading">
            <span className="acc-success-check" aria-hidden="true">✓</span>
            <div>
              <h2 id="acc-success-title">Venta registrada correctamente</h2>
              <p>{accepted ? 'Los comprobantes electrónicos han sido emitidos.' : receiptType === 'NV' ? 'La nota de venta interna se registró correctamente.' : 'Tu venta está registrada. Consulta el estado de los comprobantes a continuación.'}</p>
            </div>
          </div>
          {emissionBusy && <p className="acc-success-info" role="status">Procesando comprobantes SUNAT. No cierres esta ventana.</p>}
          {emissionError && <p className="acc-success-alert" role="alert">{emissionError}</p>}
          {pdfError && <p className="acc-success-alert" role="alert">{pdfError}</p>}
          <div className="acc-success-documents">
            {documents.map(d => {
              const ok = d.sunat_status === 'ACCEPTED';
              return <article className="acc-success-document" key={d.id}>
                <div className="acc-success-doc-icon" aria-hidden="true">▤</div>
                <div className="acc-success-doc-details">
                  <span className={`acc-success-status ${ok ? 'is-accepted' : 'is-other'}`}>{ok ? '✓ ACEPTADO' : d.sunat_status === 'OBSERVED' ? 'OBSERVADO' : d.sunat_status || 'PENDIENTE'}</span>
                  <strong>{d.full_number}</strong>
                  <span>{docTitle(d)}</span>
                </div>
                {['ACCEPTED','OBSERVED'].includes(d.sunat_status) ?
                  <button type="button" className="acc-success-download" disabled={pdfBusyId !== null} onClick={() => downloadAccessoryPdf(d)}><span aria-hidden="true">↓</span>{pdfBusyId === d.id ? 'Descargando…' : 'Descargar PDF'}</button> :
                  <span className="acc-success-wait">{hasPending ? 'Consulta el estado antes de reintentar.' : 'PDF no disponible'}</span>}
              </article>;
            })}
            {!documents.length && !emissionBusy && !emissionError && <p className="acc-success-info">{receiptType === 'NV' ? 'Documento interno, sin emisión SUNAT.' : 'Todavía no hay comprobantes disponibles.'}</p>}
          </div>
          <button type="button" className="acc-success-back" onClick={() => { onClose(); window.location.reload(); }}>Cerrar y volver a Registros <span aria-hidden="true">→</span></button>
        </section>
      </div>
    );
  }
  return (
    <div
      className="acc-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <section
        className="acc-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Venta de accesorios"
      >
        <header className="acc-header">
          <div>
            <small>MOVILESPAY · REGISTROS · CONTADO</small>
            <h2>Venta de accesorios</h2>
            <p>Selecciona productos, completa los datos y prepara el pago</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Cerrar">
            ×
          </button>
        </header>
        <div className="acc-warning">
          Confirma únicamente después de verificar el pago recibido.
        </div>
        <nav className="acc-tabs">
          {["01 Productos", "02 Cliente", "03 Pago", "04 Confirmación"].map((t, i) => (
            <button
              type="button"
              key={t}
              className={step === i ? "active" : ""}
              onClick={() => { if (i < step) setStep(i); }}
            >
              {t}
            </button>
          ))}
        </nav>
        <div className="acc-layout">
          <main className="acc-main">
            {step === 0 && (
              <>
                <h3>Accesorios disponibles</h3>
                <p className="acc-muted">
                  Catálogo y existencias de la sede actual · sin IMEI
                </p>
                <input
                  className="acc-search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Buscar accesorio, SKU o variante..."
                  aria-label="Buscar accesorio"
                />
                {loading ? (
                  <p>Cargando catálogo…</p>
                ) : error ? (
                  <p role="alert" className="acc-error">
                    {error}
                  </p>
                ) : (
                  <div className="acc-products">
                    {items
                      .filter((x) =>
                        `${x.title} ${x.sku || ""} ${x.variantName || ""}`
                          .toLowerCase()
                          .includes(search.toLowerCase()),
                      )
                      .map((x) => (
                        <article key={key(x)} className="acc-product">
                          <div className="acc-symbol">▣</div>
                          <div className="acc-product-text">
                            <strong>{x.title}</strong>
                            <small>
                              {[x.variantName, x.sku && `SKU ${x.sku}`]
                                .filter(Boolean)
                                .join(" · ") || "Accesorio"}
                            </small>
                            <span>Stock: {x.available}</span>
                          </div>
                          <div className="acc-product-end">
                            <strong>{money(price(x))}</strong>
                            <div className="acc-counter">
                              <button
                                type="button"
                                disabled={!cart[key(x)]}
                                onClick={() =>
                                  change(x, (cart[key(x)] || 0) - 1)
                                }
                              >
                                −
                              </button>
                              <input
                                type="number"
                                min="0"
                                max={x.available}
                                aria-label={`Cantidad de ${x.title}`}
                                value={cart[key(x)] || 0}
                                onChange={(e) => change(x, e.target.value)}
                              />
                              <button
                                type="button"
                                disabled={
                                  (cart[key(x)] || 0) >= Number(x.available)
                                }
                                onClick={() =>
                                  change(x, (cart[key(x)] || 0) + 1)
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </article>
                      ))}
                    {!items.length && (
                      <p>No hay accesorios disponibles en el catálogo.</p>
                    )}
                  </div>
                )}
              </>
            )}
            {step === 1 && (
              <>
                <h3>Información del cliente</h3>
                <p className="acc-muted">
                  Datos preparados para el comprobante; no se guardan todavía.
                </p>
                <div className="acc-form">
                  <label>
                    Tipo de documento
                    <Select
                      classNamePrefix="acc-react-select"
                      options={documentOptions}
                      value={documentOptions.find(x => x.value === documentType)}
                      onChange={option => {
                        setDocumentType(option.value);
                        setClient(c => ({ ...c, document: '', name: '', paternal: '', maternal: '' }));
                        setLookup({ loading: false, error: '', success: false });
                      }}
                      isSearchable={false}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 2147483647 }) }}
                    />
                  </label>
                  <label>
                    Número de {documentType} ({docLength} dígitos)
                    <input
                      value={client.document}
                      inputMode="numeric"
                      maxLength={docLength}
                      placeholder={documentType === 'DNI' ? 'Ingrese DNI' : 'Ingrese RUC'}
                      onChange={e => {
                        const value = e.target.value.replace(/\D/g, '').slice(0, docLength);
                        setClient(c => ({ ...c, document: value, name: '', paternal: '', maternal: '' }));
                      }}
                    />
                  </label>
                  <div className="acc-lookup-status" role="status" aria-live="polite">
                    {lookup.loading ? 'Consultando …' : lookup.error ? <span className="acc-error">{lookup.error}</span> : lookup.success ? '✓ Documento verificado y datos autocompletados' : `Ingrese ${docLength} dígitos para consultar automáticamente.`}
                  </div>
                  {[
                    ['name', documentType === 'RUC' ? 'Razón social' : 'Nombres'],
                    ...(documentType === 'DNI' ? [['paternal', 'Apellido paterno'], ['maternal', 'Apellido materno']] : []),
                  ].map(([field, label]) => (
                    <label key={field}>{label}
                      <input value={client[field]} disabled readOnly placeholder="Se completará automáticamente" />
                    </label>
                  ))}
                  <label>Celular
                    <input type="tel" inputMode="numeric" maxLength={9} value={client.phone}
                      onChange={e => setField('phone', e.target.value.replace(/\D/g, '').slice(0, 9))}
                      placeholder="Número de celular" />
                  </label>
                  <label>Correo electrónico *
                    <input type="email" required aria-required="true" value={client.email}
                      onChange={e => setField('email', e.target.value)} placeholder="correo@ejemplo.com" />
                    {client.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(client.email.trim()) && <span className="acc-error">Ingresa un correo electrónico válido.</span>}
                  </label>
                </div>
              </>
            )}
            {step === 2 && (
              <>
                <h3>Métodos de pago</h3>
                <p className="acc-muted">
                  Efectivo, Yape, Plin, tarjeta y transferencia. Puedes
                  distribuir el importe entre varios medios.
                </p>
                {payments.map((p, i) => (
                  <div className="acc-payment" key={i}>
                    <label>
                      Medio
                      <select
                        value={p.method}
                        onChange={(e) =>
                          setPayments((old) =>
                            old.map((x, j) =>
                              i === j ? { ...x, method: e.target.value } : x,
                            ),
                          )
                        }
                      >
                        {methods.map((m) => (
                          <option key={m}>{m}</option>
                        ))}
                      </select>
                    </label>
                    <label>
                      Importe
                      <div className="acc-money-input">
                        <span aria-hidden="true">S/</span>
                        <input
                          type="text"
                          inputMode="decimal"
                          aria-label={`Importe en soles de ${p.method}`}
                          placeholder="0.00"
                          value={p.amount}
                          onFocus={(e) => e.target.select()}
                          onChange={(e) => {
                            handlePriceInput(e);
                            const formatted = e.target.value;
                            setPayments(old => old.map((x, j) => i === j ? { ...x, amount: formatted } : x));
                          }}
                        />
                      </div>
                    </label>
                    <button
                      type="button"
                      disabled={payments.length === 1}
                      onClick={() =>
                        setPayments((old) => old.filter((_, j) => i !== j))
                      }
                    >
                      Quitar
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="acc-add"
                  onClick={() =>
                    setPayments((p) => [...p, { method: "Yape", amount: "" }])
                  }
                >
                  + Agregar medio de pago
                </button>
                <div className="acc-paytotals">
                  Total {money(totalCents / 100)} · Asignado {money(paid)} · Diferencia{" "}
                  {money((totalCents - paidCents) / 100)}
                </div>
              </>
            )}
            {step === 3 && (
              <section className="acc-review" aria-label="Revisión final de venta">
                <h3>Revisión final de la venta</h3>
                <p className="acc-muted">Revisa los datos antes de la integración de confirmación real.</p>
                <h4>Cliente</h4>
                <p>{documentType}: {client.document} · {[client.name, client.paternal, client.maternal].filter(Boolean).join(' ')}</p>
                <p>Celular: {client.phone} {client.email ? `· Correo: ${client.email}` : ''}</p>
                <h4>Productos</h4>
                {selected.map(x => <p key={key(x)}>{x.title} · {cart[key(x)]} × {money(price(x))} = {money(cart[key(x)] * price(x))}</p>)}
                <h4>Distribución de pagos</h4>
                {payments.map((p,i) => <p key={i}>{p.method}: {money(paymentCentsOf(p.amount) / 100)}</p>)}
                <strong>Total: {money(totalCents / 100)}</strong>
                <section className="acc-receipt" aria-labelledby="acc-receipt-title">
                  <div className="acc-receipt-heading">
                    <div>
                      <span className="acc-receipt-eyebrow">COMPROBANTE</span>
                      <h4 id="acc-receipt-title">Documento para esta venta</h4>
                      <p className="acc-receipt-description">Selecciona el documento solicitado por el cliente. El RUC emisor se obtiene de los accesorios.</p>
                    </div>
                    <span className="acc-receipt-icon" aria-hidden="true">▤</span>
                  </div>
                  <div className="acc-receipt-options" role="radiogroup" aria-label="Tipo de comprobante">
                    {[
                      { value: '03', title: 'Boleta', subtitle: 'Persona natural', icon: '▤' },
                      { value: '01', title: 'Factura', subtitle: 'Cliente con RUC', icon: '▣' },
                      { value: 'NV', title: 'Nota de venta', subtitle: 'Documento interno', icon: '▧' },
                    ].map(option => (
                      <label key={option.value} className={`acc-receipt-choice ${receiptType === option.value ? 'is-selected' : ''}`}>
                        <input type="radio" name="acc-receipt-type" value={option.value} checked={receiptType === option.value}
                          onChange={() => { setReceiptType(option.value); setPreflight(null); setError(''); }} />
                        <span className="acc-receipt-choice-icon" aria-hidden="true">{option.icon}</span>
                        <span className="acc-receipt-choice-copy"><strong>{option.title}</strong><small>{option.subtitle}</small></span>
                        <span className="acc-receipt-choice-check" aria-hidden="true">{receiptType === option.value ? '✓' : ''}</span>
                      </label>
                    ))}
                  </div>
                  {receiptType === '01' && documentType !== 'RUC' && (
                    <p className="acc-receipt-caution" role="status">Para solicitar factura, vuelve a Cliente y verifica un RUC de 11 dígitos.</p>
                  )}
                  <div className="acc-receipt-validation">
                    <div>
                      <strong>Validación del emisor</strong>
                      <span>Comprueba RUC y serie antes de continuar, sin emitir ni reservar correlativos.</span>
                    </div>
                    <button type="button" className="acc-receipt-verify" disabled={validatingReceipt || (receiptType === '01' && documentType !== 'RUC')} onClick={verifyReceipt}>
                      {validatingReceipt ? 'Validando…' : 'Validar emisor y serie'}
                    </button>
                  </div>
                  {preflight && <div className="acc-receipt-result" role="status">
                    <span aria-hidden="true">✓</span>
                    <div><strong>Validación completada</strong><p>Emisor: {preflight.issuer || 'Identificado'} · {preflight.requiresSunat ? `Serie: ${preflight.series || 'Por confirmar'}` : 'Documento interno'}</p></div>
                  </div>}
                  <p className="acc-receipt-disclaimer">Esta versión registra la venta sin emisión SUNAT automática. La validación no genera XML ni PDF.</p>
                </section>
              </section>
            )}
          </main>
          <aside className="acc-aside">
            <h3>Resumen de venta</h3>
            <p className="acc-muted">
              {selected.length} productos seleccionados
            </p>
            <div className="acc-lines">
              {selected.length ? (
                selected.map((x) => (
                  <div key={key(x)}>
                    <span>
                      <strong>{x.title}</strong>
                      <small>
                        {cart[key(x)]} × {money(price(x))}
                      </small>
                    </span>
                    <b>{money(cart[key(x)] * price(x))}</b>
                  </div>
                ))
              ) : (
                <p className="acc-muted">
                  Selecciona accesorios para preparar la venta.
                </p>
              )}
            </div>
            <div className="acc-total">
              <span>Total</span>
              <strong>{money(total)}</strong>
            </div>
            <p className="acc-muted">
              El stock y los importes se volverán a validar al confirmar la
              venta en la siguiente etapa.
            </p>
          </aside>
        </div>
        <footer className="acc-footer">
          <span>Venta de Accesorios</span>
          <div>
            {step > 0 && <button type="button" onClick={() => setStep(s => s - 1)}>← Volver</button>}
            <button type="button" onClick={onClose}>
              Cerrar
            </button>
            {step < 3 ? (
              <button
                type="button"
                className="acc-primary"
                onClick={nextStep}
              >
                {step === 2 ? 'Revisar venta →' : 'Continuar →'}
              </button>
            ) : (
              <button
                type="button"
                disabled={submitting}
                onClick={confirmSale}
              >
                {submitting ? "Registrando…" : "Confirmar venta"}
              </button>
            )}
          </div>
          {error && <span role="alert" className="acc-error">{error}</span>}
          {validationMessage && step < 3 && <span role="alert" className="acc-error acc-validation">{validationMessage}</span>}
        </footer>
      </section>
    </div>
  );
}
